// changes

const colorAxis = {
  dataClasses: [
      {
      to: 0,
      color: '#D9D8D8',
      plotBorderColor:'white'
    },
    {
      from: 1,
      to: 100,
      color: '#CCDAFF',
      plotBorderColor:'white'
    },
    {
      from: 100.01,
      to: 200,
      color: '#B5C4EC',
      plotBorderColor:'white'
    },
    {
      from: 200.01,
      to: 300,
      color: '#9EAFDA',
      plotBorderColor:'white'
    },
    {
      from: 300.01,
      to: 400,
      color: '#879BC8',
      plotBorderColor:'white'
    },
    {
      from: 400.01,
      to: 500,
      color: '#7086B6',
      plotBorderColor:'white'
    },
    {
      from: 500.01,
      to: 1000,
      color: '#5973A4',
      plotBorderColor:'white'
    },
    {
      from: 1000.01,
      to: 2000,
      color: '#426093',
      plotBorderColor:'white'
    },
    {
      from: 2000.01,
      to: 3000,
      color: '#284D82',
      plotBorderColor:'white'
    },
    {
      from: 3000.01,
      to: 4000,
      color: '#003C71',
      plotBorderColor:'white'
    },
    {
      from: 4000.01,
      to: 5000,
      color: '#03234F',
      plotBorderColor:'white'
    },
      {
      from: 5000.01,
      color: '#031F47',
      plotBorderColor:'white'
    },
  ],
}
export default colorAxis